import React, { useContext, useEffect, useState } from "react";
import "../../../../styles/workspace_styles/CustomerAdministratorStyles/Devices/Device.css";
import { LoadShortDate } from "../../../../functions/LoadShortDate.js";
import { LoadShortTime } from "../../../../functions/LoadShortTime.js";
import {thingsBoardMicroserviceUrl} from "../../../../microservices/thingsboard_microservice.js";
import { AppContext } from "../../../AppProvider.jsx";
const Details = ({device,showDeviceDetails}) =>{
    if(!device || !showDeviceDetails) return null;
    return (
        <div className="device-details-container">
            <div>
                <div className="device-details-property-container">
                    <p>Name</p>
                    <input disabled value={device.name?device.name:''}/>
                </div>
                <div className="device-details-property-container">
                    <p>Label</p>
                    <input disabled value={device.label?device.label:''}/>
                </div>
                <div className="device-details-property-container">
                    <p>Description</p>
                    <input disabled value={device.description?device.description:''} />
                </div>
                <div className="device-details-property-container">
                    <p>Customer name</p>
                    <input disabled value={device?.customer?.external && device.customer.external.name? device.customer.external.name:''} />
                </div>
            </div>
        </div>
    );
};
const LatestTelemetry =({device,showLatestTelemetry}) =>{
    if(!device || !showLatestTelemetry) return null;
    return(
        <div className="latest-telemetry-container">
            <div className="latest-telemetry-header">
                <h5>Telemetry</h5>
            </div>
            <div className="latest-telemetry-table-container">
                <table className="latest-telemetry-table">
                    <thead>
                        <tr id="latest-telemetry-table-header">
                            <th>Last update date</th>
                            <th>Last update time</th>
                            <th>Key</th>
                            <th>Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {device.latestTelemetry.map((latestTelemetry,index) =>(
                            <tr key={index}>
                                <td>{LoadShortDate(latestTelemetry.timeStamp)}</td>
                                <td>{LoadShortTime(latestTelemetry.timeStamp)}</td>
                                <td>{latestTelemetry.key}</td>
                                <td>{latestTelemetry.value.toString()}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
const BillingDetails = ({device,showBillingDetails}) => {
     if(!showBillingDetails) return null;
     return(
        <div className="billing-details-container">
            <p style={{
                width:'100%',
                textAlign:'center'
            }}>Feature coming soon...</p>
        </div>
     );
}
const Device = ({deviceId,showDeviceComponent,setShowDeviceComponent}) =>{
    const {user,logout,customerIotProfile,setShowBottomRightMessageBox,setBottomRightMessageBoxMessage} = useContext(AppContext);
    const [showDeviceDetails,setShowDeviceDetails] = useState(true);
    const [showLatestTelemetry,setShowLatestTelemetry] = useState(false);
    const [showBillingDetails,setShowBilingDetails] = useState(false);
    const [device,setDevice] = useState();
    async function fetchDeviceById(){
        try{
            const url = `${thingsBoardMicroserviceUrl}/customers/users/admin/${customerIotProfile?.id}/devices/${deviceId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDevice(responseData);
            }
            else if(Number(response.status) === 401) logout();
            else throw new Error(`response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when retrieving the device from the server',error);
        }
    }
    useEffect(() =>{
        if(!deviceId) return;
        if(device) setDevice(null);
        fetchDeviceById();
    },[deviceId]);
    function displayDetails(){
        setShowLatestTelemetry(false);
        setShowBilingDetails(false);
        setShowDeviceDetails(true);
    }
    function displayLatestTelemetry(){
        setShowDeviceDetails(false);
        setShowBilingDetails(false);
        setShowLatestTelemetry(true);
    }
    function displayBillingDetails(){
        setShowDeviceDetails(false);
        setShowLatestTelemetry(false);
        setShowBilingDetails(true);
    }
    if(!deviceId || !showDeviceComponent) return null;
    return(
        <div className="device-container">
            <div className="device-container-header">
                <div>
                    <h3>{`${device? device.name:'Loading...'}`}</h3>
                    <h4>Device details</h4>
                </div>
                <div>
                    <p onClick={() =>{
                        displayDetails();
                        setShowDeviceComponent(false);
                    }}>&#10006;</p>
                </div>
            </div>
            <div className="device-container-navigation-bar">
                <button
                    style={{backgroundColor:showDeviceDetails? 'lightgray':'transparent'}}
                    onClick={() => displayDetails()}>Details</button>
                <button
                    style={{backgroundColor:showLatestTelemetry? 'lightgray':'transparent'}}
                    onClick={() => displayLatestTelemetry()}>Latest telemetry</button>
                <button
                    style={{backgroundColor:showBillingDetails? 'lightgray':'transparent'}}
                    onClick={() => displayBillingDetails()}>Billing</button>
            </div>
            <div className="device-container-body">
                <Details device={device} showDeviceDetails={showDeviceDetails} />
                <LatestTelemetry device={device} showLatestTelemetry={showLatestTelemetry} />
                <BillingDetails device={device} showBillingDetails={showBillingDetails}/>
            </div>
        </div>
    );
};
export default Device;